import  { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./PayOut.css";
import Select from "react-select";
import "react-phone-input-2/lib/style.css";
import { payoutInitiateDash } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import Modal from "./Modal";
import OverLoad from "./OverLoad";
import { useSelector } from "react-redux";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const signUpSchema = Yup.object({
  amount: Yup.string().required("Please enter Amount"),
  bene_name: Yup.string().required("Please enter Name"),
  bene_acc: Yup.string().required("Please enter Account No"),
  bene_ifsc: Yup.string().required("Please enter Ifsc Code"),
  bene_address: Yup.string().required("Please enter Address"),
});

function FormHeader({ setTypeError, setExcelFile, setExcelData }) {
  const [selectedOptions, setSelectedOptions] = useState("");
  const [typeValue, setTypeValue] = useState("");
  const [modeSelected, setModeSelected] = useState("");
  const [modeValue, setModeValue] = useState("");
  const [startLoading, setStartLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const token = useSelector(store => store.userReducer.token);
  const role = useSelector(store => store.userReducer.role);

  const initialValues = {
    bene_bank_name: "",
    amount: "",
    bene_name: "",
    bene_acc: "",
    bene_ifsc: "",
    bene_email: "",
    bene_mobile: "",
    bene_acc_type: typeValue,
    mode: modeValue,
    bene_address: "",
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit,setFieldValue } =
    useFormik({
      initialValues,
      // validationSchema: signUpSchema,
      onSubmit: (values, action) => {
        (values.mode = modeValue), (values.bene_acc_type = typeValue);

        setFormData(values);
        role == 'mops' ? setIsModal(true) :  callApi()

        action.resetForm();
      },
    });

  const callApi = async () => {
    setStartLoading(true);

    let formData = {
      amount: values.amount,
      mode: values.mode,
      ifscCode: values.bene_ifsc,
      branchname: values.bene_branch_name,
      accountNo: values.bene_acc,
      beneName: values.bene_name,
      beneAddress: values.bene_address,
      beneBankName: values.bene_bank_name,
      beneEmail: values.bene_email,
      beneMobile: values.bene_mobile,
    };

    const data = await payoutInitiateDash(formData, token);
    if (data) {
      toast.info(data.RESPONSE_MESSAGE);
    } else {
      toast.error("Some issue occured");
    }

    setStartLoading(false);
  };

  const myChange = (e) => {
    setSelectedOptions(e);
    setTypeValue(e.value);
  };


  
  const myChange2 = (e) => {
    setModeSelected(e);
    setModeValue(e.value);
  };

  useEffect(() => {}, [modeValue, typeValue]);

  const options = [
    { value: "IMPS", label: "IMPS" },
    { value: "NEFT", label: "NEFT" },
    { value: "RTGS", label: "RTGS" },
  ];
  const accountOptions = [
    { value: "CURRENT", label: "CURRENT" },
    { value: "SAVING", label: "SAVING" },
  ];

  return (
    <div>
      {startLoading ? (
        <OverLoad />
      ) : (
        <div>
          <div className="out-head">
            <h2 className="area-top-title-pay-out">Pay Out Form</h2>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="">
              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_acc_type"
                    className="input-label text-base mb-2"
                  >
                    Account Type <span className="astrisk">*</span>
                  </label>

                  <div className="select-height">
                    <Select
                      name="bene_acc_type"
                      className="input-field-select"
                      value={selectedOptions}
                      styles={{
                        height: "4rem",
                      }}
                      onChange={myChange}
                      options={accountOptions}
                    />
                  </div>
                </div>
                <div className="">
                  <label htmlFor="mode" className="input-label text-base mb-2">
                    Transfer Mode <span className="astrisk">*</span>
                  </label>

                  <Select
                    name="mode"
                    className="input-field-select"
                    value={modeSelected}
                    onChange={myChange2}
                    options={options}
                  />
                  {errors.mode && touched.mode ? (
                    <p className="form-error">{errors.mode}</p>
                  ) : null}
                </div>
                <div className="">
                  <label
                    htmlFor="bene_bank_name"
                    className="input-label text-base mb-2"
                  >
                    Branch Name <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_branch_name"
                    placeholder="Bank Branch Name"
                    value={values.bene_branch_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>   
              </div>

              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_bank_name"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Bank Name <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_bank_name"
                    placeholder="Beneficiary Bank Name"
                    value={values.bene_bank_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="">
                  <label
                    htmlFor="amount"
                    className="input-label text-base mb-2"
                  >
                    Amount <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="amount"
                    id="amount"
                    placeholder="Amount"
                    value={values.amount}
                    onChange={(e) => {
                    const cleanedValue = e.target.value.replace(/\s/g, "");
                    setFieldValue("amount", cleanedValue);
                    }}
                    onBlur={handleBlur}
                  />
                  {errors.amount && touched.amount ? (
                    <p className="form-error">{errors.amount}</p>
                  ) : null}
                </div>

                <div className="">
                  <label
                    htmlFor="bene_name"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Name <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_name"
                    placeholder=" Beneficiary Name"
                    value={values.bene_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_name && touched.bene_name ? (
                    <p className="form-error">{errors.bene_name}</p>
                  ) : null}
                </div>
              </div>

              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_acc"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary A/C Number <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_acc"
                    placeholder="Account Number"
                    value={values.bene_acc}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_acc && touched.bene_acc ? (
                    <p className="form-error">{errors.bene_acc}</p>
                  ) : null}
                </div>

                <div className="">
                  <label
                    htmlFor="bene_ifsc"
                    className="input-label text-base mb-2"
                  >
                    IFSC Code <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_ifsc"
                    placeholder="IFSC Code"
                    value={values.bene_ifsc}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_ifsc && touched.bene_ifsc ? (
                    <p className="form-error">{errors.bene_ifsc}</p>
                  ) : null}
                </div>
                <div className="">
                  <label
                    htmlFor="bene_address"
                    className="input-label text-base mb-2"
                  >
                    Address <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_address"
                    id="amount"
                    placeholder="Address"
                    value={values.bene_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_address && touched.bene_address ? (
                    <p className="form-error">{errors.bene_address}</p>
                  ) : null}
                </div>
              </div>
              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_mobile"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Mobile Number <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_mobile"
                    placeholder="Beneficiary Mobile Number"
                    value={values.bene_mobile}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {/* {errors.bene_mobile && touched.bene_mobile ? (
                    <p className="form-error">{errors.bene_mobile}</p>
                  ) : null} */}
                </div>

                <div className="">
                  <label
                    htmlFor="bene_email"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Email <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_email"
                    placeholder="Beneficiary Email"
                    value={values.bene_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_email && touched.bene_email ? (
                    <p className="form-error">{errors.bene_email}</p>
                  ) : null}
                </div>

                <div className="">
                  <label
                    htmlFor="remarks"
                    className="input-label text-base mb-2"
                  >
                    Remarks <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="remarks"
                    id="email"
                    placeholder="Remarks"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.remarks && touched.remarks ? (
                    <p className="form-error">{errors.remarks}</p>
                  ) : null}
                </div>
              </div>

              <div className="sub-button">
                <button type='submit' className="addUser-btn-1">Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isModal && 
      <Modal 
        callApi = {callApi}
        setIsModal = {setIsModal}
      />}
    </div>
  );
}

export default FormHeader;
